class GorgiasChat extends HTMLElement {
  constructor() {
    super();
    this.open = false;
  }
  connectedCallback() {
    if (window.delayGorgiasLoad) {
      let intervalId = setInterval(() => {
        if (document.documentElement.dataset.pinned === '1') {
          return;
        }
        this.load();
        clearInterval(intervalId);
      }, 250);
    } else {
      this.load();
    }

    let button = this.querySelector('#chat-icon');
    button.addEventListener('click', this.onClick.bind(this));
  }

  load() {
    this.loadGorgiasScript().then((script) => {
      let initGorgiasChatPromise = window.GorgiasChat
        ? window.GorgiasChat.init()
        : new Promise((resolve) => {
            window.addEventListener('gorgias-widget-loaded', () => {
              resolve();
            });
          });

      initGorgiasChatPromise.then(async () => {
        window.GorgiasChat.on('widget:opened', (data) => {
          this.open = true;
        });

        window.GorgiasChat.on('widget:closed', (data) => {
          this.open = false;
          this.setCookie('chat-opened', '', { path: '/' });
        });

        setTimeout(() => {
          if (window.GorgiasChat.isChatOnline()) {
            this.classList.remove('hidden');
            if (this.getCookie('chat-opened')) {
              window.GorgiasChat.open();
            }
          }
        }, 500); // this delay is necessary to ensure the chat is fully loaded before checking if it is online
      });
    });
  }

  onClick() {
    if (this.open) {
      this.closeChat();
    } else {
      this.openChat();
    }
  }

  openChat() {
    this.setCookie('chat-opened', '1', { path: '/' });
    window.GorgiasChat.open();
  }

  closeChat() {
    window.GorgiasChat.close();
  }

  isLive() {
    return window.GorgiasChat.isChatOnline();
  }

  loadGorgiasScript() {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.setAttribute('id', 'gorgias-chat-widget-install-v3');
      script.async = true;
      script.src = this.dataset.src;
      script.onload = () => resolve(script);
      script.onerror = () => reject(new Error('Failed to load Gorgias script.'));

      document.head.appendChild(script);
    });
  }

  //setCookie not used at present
  setCookie(name, value, options = {}) {
    options = {
      path: '/',
      value: '1',
    };

    if (options.expires instanceof Date) {
      options.expires = options.expires.toUTCString();
    }

    let updatedCookie = encodeURIComponent(name) + '=' + encodeURIComponent(value);

    for (let optionKey in options) {
      updatedCookie += '; ' + optionKey;
      let optionValue = options[optionKey];
      if (optionValue !== true) {
        updatedCookie += '=' + optionValue;
      }
    }

    document.cookie = updatedCookie;
  }

  //getCookie not used at present
  getCookie(name) {
    let matches = document.cookie.match(
      new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[]\\\/+^])/g, '\\$1') + '=([^;]*)'),
    );
    return matches ? decodeURIComponent(matches[1]) : undefined;
  }
}

customElements.define('gorgias-chat', GorgiasChat);
